module.exports = __webpack_public_path__ + "static/media/bath-fill.23d58706.png";